var factsheetHeader = {
	label: {
		highLowBar: "Intervallo Intraday",
		lastPriceDateTime: "Data/Ora",
		volume: "Volume",
		isin: "ISIN",
		wkn: "WKN",
		numberOfConstituents: "Numero di Componenti",
		country: "Paese",
		symbol: "Simbolo",
		fundIssuer: "Emittente",
		fundCategory: "Categoria",
		pea: "PEA ",
		pme: "PEA-PME",
		srd: "SRD",
		tradingStatus: "Posizione Commerciale",
		perf1Year: "Perf. 1 Anno",
		perf5Years: "Perf. 5 Anni",
		perf1Week: "Perf. 1 Settimana",
		perf1Month: "Perf. 1 Mese",
		suspended: "Sospeso",
		marketStatus: "Fase di Mercato",
		tradingPhase: "Fase di Negoziazione",
		expectedDividends: "Dividendi Attesi",
		expectedPriceEarningsRatio: "Rapporto Prezzo/Utili Atteso"
	},
	"true": "Si",
	"false": "No",
	open: "Aperto",
	close: "Chiuso"
};
var it = {
	factsheetHeader: factsheetHeader
};

export { it as default, factsheetHeader };
